<template>
  <CDialog
    @close="emit('close')"
    @outer-click="emit('close')"
    :show="show"
    :no-header="true"
    :custom-class="'max-w-[421px]'"
  >
    <div class="p-5">
      <CRoundedIcon
        class="!text-4.5xl"
        :color="
          type === 'success'
            ? '!text-green bg-green-100'
            : '!text-red bg-red-100'
        "
        :icon="
          type === 'success' ? 'icon-filled-tick-circle' : 'icon-filled-warning'
        "
      />
      <p
        class="text-base leading-130 font-normal text-gray-700 text-center mt-2 mx-auto"
      >
        {{ $t(planDescription[type]) }}
      </p>
      <div class="mt-7 grid grid-cols-2 gap-4">
        <CButton
          variant="info"
          class="w-full"
          @click="emit('close')"
          :text="$t('cancel')"
        />
        <template v-if="type === 'success'">
          <CButton
            variant="success_info"
            :text="$t('activate')"
            class="w-1/2"
            :loading="loading"
            :disabled="loading"
            @click="activateBots"
          />
        </template>
        <template v-if="type === 'balance'">
          <RouterLink to="/wallet">
            <CButton
              @click="emit('close')"
              variant="warning-yellow"
              :text="$t('wallet')"
              class="w-full"
            />
          </RouterLink>
        </template>
        <template v-if="type === 'plan'">
          <RouterLink to="/plan">
            <CButton
              @click="emit('close')"
              variant="warning-yellow"
              :text="$t('plan')"
              class="w-full"
            />
          </RouterLink>
        </template>
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CRoundedIcon from "@/components/Common/CRoundedIcon.vue";
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CButton from "@/components/Common/CButton.vue";
import { computed } from "vue";

interface Props {
  show: boolean;
  loading: boolean;
  type?: "success" | "balance" | "plan";
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
  (e: "activateBots"): void;
}>();

const planDescription = computed(() => {
  return {
    success: "stop_success_warning_desc",
    balance: "stop_balance_warning_desc",
    plan: "stop_plan_warning_desc",
  };
});

const activateBots = () => {
  emit("activateBots");
};
</script>

<style scoped></style>
